import React from 'react';
import styled from 'styled-components';

const StyledWrapper = styled.div`
  background: ${p => p.theme.primary500};
  border-radius: 4px;
  color: #fff;
  display: inline-block;
  font-family: sans-serif;
  font-size: 13px;
  font-weight: normal;
  padding: 4px 8px;
  vertical-align: middle;
`;

export default StyledWrapper;
